import { SystemSession } from './system.ts'

// TODO: QFMP-5047 For now, we're using the system session for the public service.
// A public session should have a very restricted set of privileges.
export const PublicSession = SystemSession
